import * as core from '../../../../../../../core'

import { query } from './stakeholders-by-validation-status.query'

export const RESOURCE = {
  payload: {
    alias: 'stakeholders.by.validation.status',
    description: 'Chart view of stakeholders by validation status',
    name: 'Stakeholders by Validation Status',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
